import React from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import "../../styles/confirm.scss";

const Confirm = ({
  title,
  desc,
  icon: Icon,
  actions,
  onActionClick,
  onClose,
}) => {
  const handleActionClick = (action) => {
    onActionClick(action);
    onClose && onClose();
  };

  return (
    <div className="confirm">
      <div className="confirm-content">
        {Icon && <Icon />}
        <span className="confirm-content__title">{title}</span>
        <span className="confirm-content__desc">{desc}</span>
        <div
          className="confirm-content-ctas"
          style={{ gridTemplateColumns: `repeat(${actions.length}, auto)` }}
        >
          {actions.map((action, index) => {
            return (
              <Button
                key={action.id ?? `cofirm-action-${index}`}
                label={action.label}
                variant={action.variant ?? "primary"}
                onClick={() => handleActionClick(action)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

Confirm.propTypes = {};

export default Confirm;
